import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { HeaderService } from './header.service';
import { UserDetailsService } from './user-details.service';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DevMyTitleService {
  apiURL = environment.oneLogApi;
  constructor(
    private http: HttpClient,
    private userDetails: UserDetailsService,
    private headerService: HeaderService
  ) {}

  getProducts(postData: any = [], getData: string = ''): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<any>(
        this.apiURL + '/dev_my_title_get_products' + getData,
        postData,
        requestOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  download(postData: any = [], getData: string = '', url: string) {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };
    const headers = new HttpHeaders()
      //.set('Content-Type', 'text/plain; charset=utf-8')
      .set('Content-Type', 'application/json')
      .set('Authorization', this.userDetails.getUserToken())
      .set('userToken', this.userDetails.getUser());

    const body = JSON.stringify(postData);
    console.log(body);

    // this.http.post('http://127.0.0.1:8000/api/dev_my_title_get_products'+ getData, [], {responseType: 'blob'})
    this.http
      //.post(this.apiURL + '/dev_my_title_get_products', body, {
      .post(`${this.apiURL}${url}`, body, {
        headers,
        responseType: 'blob',
      })
      .subscribe((resp: any) => {
        saveAs(resp, 'dev-my-title-' + new Date().toLocaleString() + '.xlsx');
      });
  }

  getPublisherUsers(postData: any = [], getData: string = ''): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<any>(
        this.apiURL + '/get_user_by_title' + getData,
        postData,
        requestOptions
      )
      .pipe(retry(1), catchError(this.handleError));
  }

  postRequest(
    postData: any = [],
    getData: string = '',
    url: string = ''
  ): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<any>(this.apiURL + url + getData, postData, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  getRequest(getData: string = '', url: string = ''): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return this.http
      .get<any>(this.apiURL + url + getData, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
